import { render, staticRenderFns } from "./AddTaskDialog.vue?vue&type=template&id=a4114230&"
import script from "./AddTaskDialog.vue?vue&type=script&lang=js&"
export * from "./AddTaskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports